import { render, staticRenderFns } from "./videoCapacity.vue?vue&type=template&id=71862d90&scoped=true&"
import script from "./videoCapacity.vue?vue&type=script&lang=js&"
export * from "./videoCapacity.vue?vue&type=script&lang=js&"
import style0 from "./videoCapacity.vue?vue&type=style&index=0&id=71862d90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71862d90",
  null
  
)

export default component.exports